/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmMotorZpracovaniEPA extends GContentBase<SeznamAdmMotorZpracovaniEPAObj> {
        private seznamObj: SeznamAdmMotorZpracovaniEPAObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmMotorZpracovaniEPAObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmMotorZpracovaniEPANew",
                contentCaption: "jres:33001024",  //RC 33001024 : Automatické motory
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_epa}"
                },
                gridSettings: {
                    columnOrder: `nazev,adr_odes,subj_start,subj_obsah,poznamka,poradi,ixs_typ_txt,zpusob_dor_txt,${this.seznamObj.isGinUpsrPovol == true ? "ixs_fsk_txt," : ""}ixs_epa,dat_zmena,zmenu_prov_txt`
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmMotorZpracovaniEPAObj extends GAdmSeznamBase {
        typ_mbx: number;
        mailbox: string;
        isGinUpsrPovol: boolean;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            const cntInitializer = ["Gordic.Adm.WebControls.DetailAdmMotorZpracovaniEPA", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid),
                openDialog: this.tabOpen
            }]
            const inputParams = {
                ID: "DetailAdmMotorZpracovaniEPA",
                newRecord: isNew,
                typ_mbx: this.typ_mbx,
                ixs_epa: isNew == true ? null : data.ixs_epa,
                mailbox: isNew == true ? (this.mailbox ? this.mailbox : null) : data.mailbox
            }
            this.openDialogOrModalWindow(cntInitializer, inputParams);
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", "actOpenDialogVyberovaSkupina*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar([
                "actOpenDetail*",
                "actOpenDialogVyberovaSkupina*"
            ])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:33001025").addField("gselectbox", Gordic.Prefabs.Select.admGinsmbx(), { //RC 33001025 : Schránka
                name: "mailbox",
                model: "model.mailbox=value.mailbox",
                dropdown: true,
                disabled: (this.mailbox) ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.mailbox)
                hardFilter["mailbox"] = this.mailbox;
            return hardFilter;
        }

        collectData(data: any) {
            if (this.mailbox)
                data["mailbox"] = this.mailbox;
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmMotorZpracovaniEPA.list({
                filters: filterData,
                fragments: [ (this.typ_mbx == 30 || this.typ_mbx == 50) ? "ds" : "mb" ]
            }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actSeznamFunkceAdmMotorZpracovaniEPA?.update({ enabled: objArr.count == 1 })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.ixs_epa}`,
                nazev: data["nazev"]
            }
        }
    }
}